var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-2"},[_c('img',{attrs:{"src":_vm.logo,"alt":_vm.parameters.store.cf1fant,"height":_vm.height,"width":"auto"}}),_c('p',{staticClass:"body-2"},[_vm._v(" "+_vm._s(_vm.parameters.store.b2ddescri)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }